import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";

type SubTab = {
  key: string;
  label: string;
  path?: string;
  isLink?: boolean;
};

const subTabs: SubTab[] = [
  { key: "overview", label: "seller.subTabs.overview" },
  { key: "benefits", label: "main.marketplace.seller.benefits.title" },
  { key: "howItWorks", label: "main.marketplace.seller.faq.title" },
  { key: "packages", label: "main.marketplace.seller.packages.title1" },
  {
    key: "Conditions",
    label: "seller.subTabs.Conditions",
    path: "/seller/conditions",
    isLink: true,
  },
  { key: "app", label: "seller.subTabs.app", path: "/seller/app", isLink: true },
];

const SellerSubTabs: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const handleTabClick = (tab: SubTab) => {
    if (tab.isLink && tab.path) {
      // For external links, let the Link component handle navigation
      return;
    }

    const section = document.getElementById(tab.key);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const isActiveTab = (tab: SubTab) => {
    if (tab.isLink && tab.path) {
      return location.pathname === tab.path;
    }
    // For internal tabs, check if we're on the main seller page and it's the overview tab
    if (tab.key === "overview" && location.pathname === "/seller") {
      return true;
    }
    return false;
  };

  return (
    <nav className="flex justify-end gap-4 border-b py-4 pr-6">
      {subTabs.map(tab => {
        // External link detection
        const isExternal =
          tab.path && (tab.path.startsWith("http://") || tab.path.startsWith("https://"));
        if (tab.isLink && tab.path) {
          if (isExternal) {
            return (
              <a
                key={tab.key}
                href={tab.path}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-2 font-medium text-gray-700 transition-colors hover:text-blue-600"
              >
                {t(tab.label)}
              </a>
            );
          }
          // Internal link: use NavLink for active styling
          return (
            <NavLink
              key={tab.key}
              to={tab.path}
              className={({ isActive }) =>
                `px-3 py-2 font-medium transition-colors ${
                  isActive
                    ? "border-b-2 border-blue-600 text-blue-600"
                    : "text-gray-700 hover:text-blue-600"
                }`
              }
              end
            >
              {t(tab.label)}
            </NavLink>
          );
        }

        return (
          <button
            key={tab.key}
            onClick={() => handleTabClick(tab)}
            className={`px-3 py-2 font-medium transition-colors ${
              isActiveTab(tab)
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-700 hover:text-blue-600"
            }`}
          >
            {t(tab.label)}
          </button>
        );
      })}
    </nav>
  );
};

export default SellerSubTabs;
